<template>

    <div class="canvas::editor-admin-ToolbarTop flex w-full flex-col">

        <div class="mb-0 w-full">
            <div class="flex">

                <div class="px-5 py-10 sm:px-10">

                    <div class="flex items-center">
                        <h4 class="text-2xl font-bold inline-block">{{ title }}</h4>

                        <button
                            class="ml-3 text-blue-500 rounded px-2 py-1 hover:bg-gray-50"
                            @click="$emit('update:fullscreen', !fullscreen)">
                            <i
                                class="far"
                                :class="fullscreen ? 'fa-compress-alt' : 'fa-expand-alt'"/>
                        </button>

                    </div>

                    <h6 class="text-lg text-gray-500">{{ instruction }}</h6>

                </div>

                <div class="versionInfo ml-auto text-right flex px-5 py-10 sm:px-10">

                    <div>
                        <div
                            class="label inline-flex items-center px-3 py-0.5 rounded-full text-sm font-medium"
                            :class="versionState === 'live' ? 'bg-green-100 text-green-800' : 'bg-yellow-100 text-yellow-800'">
                            {{ versionState | camelcase }}
                        </div>

                        <h6 class="card-subtitle mb-0 mt-2 text-gray-500" v-if="activeCanvasVersion">
                            {{ versionState === 'live' ? 'Gepubliceerd' : 'Live versie gepubliceerd' }}
                            <template v-if="authorName">door <b>{{ authorName }}</b></template>
                            op <b>{{ activeCanvasVersion.activated_at | date('%d-%m-%Y %H:%M') }}</b>
                        </h6>
                    </div>

                    <div v-if="currentLanguageToShow" class="ml-4">
                        <i class="flag-icon"
                           :class="'flag-icon-' + (currentLanguageToShow == 'en' ? 'gb' : currentLanguageToShow)"></i>
                    </div>

                </div>

            </div>
        </div>

    </div>

</template>

<script>

export default {

    props: {
        activeCanvasVersion: Object,
        canvasVersion: Object,
        versionState: String,
        activeMode: String,
        title: String,
        instruction: String,
        currentLanguageToShow: String,
        fullscreen: Boolean,
    },

    computed: {

        authorName() {
            return this.canvasVersion.canvas.author?.name;
        },

    },

}

</script>

<style lang="scss" scoped>

.canvas\:\:editor-admin-ToolbarTop {
    border-bottom: 1px solid #ddd !important;

    .card-subtitle.mb-0 {
        margin-bottom: 0 !important;
    }

    .flag-icon {
        font-size:  20px;
        margin-top: 3px;
    }

    .versionInfo h6 {
        margin: 5px 0 0 0 !important;
    }

}

</style>
